module.exports = __webpack_public_path__ + "img/group3.8055d847.png";